
// Document Ready
$(()=> {

	// ショップサーチ地域ナビ
	if($('.searchlink__wrap').length) {
		controlSearchlinkAreaNav();
	}

});

/**
 * ショップサーチ地域ナビの表示制御
 */
function controlSearchlinkAreaNav() {
	let $areaNavBtn     = $('.searchlink-area-list__item');
	let activeClassName = 'active';

	$areaNavBtn.on('click', (ev)=> {
		let $self = $(ev.currentTarget);
		let selectArea = $self.data('searchlink-nav');
		let $storeList = $('.searchlink-store');

		// 初期化
		$storeList.hide();
		$areaNavBtn.removeClass(activeClassName);

		// 対象店舗の表示
		$(`[data-searchlink-area="${selectArea}"]`).show();
		$self.addClass(activeClassName);
	});
}
